import { render, staticRenderFns } from "./activeDownUp.vue?vue&type=template&id=76d139a0&scoped=true&"
import script from "./activeDownUp.vue?vue&type=script&lang=js&"
export * from "./activeDownUp.vue?vue&type=script&lang=js&"
import style0 from "./activeDownUp.vue?vue&type=style&index=0&id=76d139a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d139a0",
  null
  
)

export default component.exports